import { apiClient, getUserId } from "./apiClient";

/*
 * ONLY these Aviator endpoints are used by the front:
 *   POST /bet/place            POST /cashout
 *   GET  /current-round        GET  /current-round-bets
 *   GET  /bet/:betId           GET  /bet-history
 *   GET  /round-history        GET  /round/:roundId/bets
 *   GET  /round/:roundId/stats
 *   POST /auto-bet/heartbeat   GET  /get-auto-bet
 *   PUT  /auto-bet             POST /auto-bet/disable
 */

export const placeAviatorBet = ({
  amount,
  roundId = null,
  betType = "MANUAL",
  autoCashOut = null,
}) => {
  const payload = { userId: getUserId(), amount, betType };
  if (roundId) payload.roundId = roundId;
  if (betType === "AUTO" && autoCashOut) payload.autoCashOut = autoCashOut;
  return apiClient.post("/bet/place", payload);
};

export const cashoutAviatorBet = (betId) =>
  apiClient.post("/cashout", { userId: getUserId(), betId });

export const getCurrentRound = () => apiClient.get("/current-round");
export const getCurrentRoundWithBets = () => apiClient.get("/current-round-bets");
export const getUserBet = (betId) => apiClient.get(`/bet/${betId}`);
export const getBetHistory = (limit = 50) =>
  apiClient.get("/bet-history", { limit });
export const getRoundHistory = (limit = 30) =>
  apiClient.get("/round-history", { limit });
export const getRoundBets = (roundId) => apiClient.get(`/round/${roundId}/bets`);
export const getRoundStats = (roundId) =>
  apiClient.get(`/round/${roundId}/stats`);

export const autoBetHeartbeat = () => apiClient.post("/auto-bet/heartbeat", {});
export const getAviatorAutoBet = () => apiClient.get("/get-auto-bet");
export const saveAviatorAutoBet = (payload) =>
  apiClient.put("/auto-bet", payload);
export const disableAviatorAutoBet = () =>
  apiClient.post("/auto-bet/disable", {});
